import React, { useEffect, useRef, useState } from "react";
import { Collapse, Form, Offcanvas, Spinner, Table } from "react-bootstrap";
import Moment from "react-moment";
import { studyMedicalReviewServices } from "../../../../APIServices/studyMedicalReviewServices";
import Swal from "sweetalert2";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const ReviewQueryHistory = ({ Show, Hide, Title, studyId, siteId, reviewId, getSubjectMedicalReviewer }) => {
  const [openAction, setOpenAction] = useState(false);
  const [closeAction, setCloseAction] = useState(false);
  const [openedAction, setOpenedAction] = useState(false);
  const [closedAction, setClosedAction] = useState("");
  const [loader, setLoader] = useState(false);
  const [reviewQuery, setReviewQuery] = useState("");
  const [remark, setRemark] = useState("");
  const [queryList, setQueryList] = useState([]);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getStudySubjectMedicalReviewComments = async () => {
    setLoader(true)
    setQueryList([])
    let data = await studyMedicalReviewServices.getStudySubjectMedicalReviewComments(studyId, siteId, reviewId)
    setLoader(false)
    setQueryList(data?.data || [])
  }

  const addNewStudySubjectMedicalReviewComment = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Open New Query?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Open it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setOpenedAction(true)
        let userData = {}
        userData.studyId = studyId
        userData.siteId = siteId
        userData.reviewId = reviewId
        userData.comment = reviewQuery
        let data = await studyMedicalReviewServices.addNewStudySubjectMedicalReviewComment(userData)
        if (data?.statusCode === 200) {
          getSubjectMedicalReviewer()
          getStudySubjectMedicalReviewComments()
          setReviewQuery("")
          setRemark("")
        }
        setOpenedAction(false)
      }
    });
  };

  const closedStudySubjectMedicalReviewComment = async (commentId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Close Query?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Close it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setClosedAction(commentId)
        let userData = {}
        userData.studyId = studyId
        userData.siteId = siteId
        userData.commentId = commentId
        userData.remark = remark
        let data = await studyMedicalReviewServices.closedStudySubjectMedicalReviewComment(userData)
        if (data?.statusCode === 200) {
          getSubjectMedicalReviewer()
          getStudySubjectMedicalReviewComments()
        }
        setClosedAction("")
      }
    });
  };

  useEffect(() => {
    if (studyId && siteId && reviewId) {
      getStudySubjectMedicalReviewComments()
    }
  }, [studyId, siteId, reviewId]);
  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        placement="end"
        style={{ width: "700px" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="mb-2">
            {(StudyMode === "SDV Live Mode" || StudyMode === "SDV QC Mode") &&
              <div className="w-25">
                <button
                  onClick={() => setOpenAction(!openAction)}
                  className={`updateProfile`}
                >
                  <span>{openAction ? "Close" : "Add Query"}</span>
                </button>
              </div>
            }
            <Collapse in={openAction}>
              <div>
                <Form.Group className="mb-1">
                  <Form.Label className="fw-bold mb-1">
                    Query{" "}
                    <abbr title="Required" className="text-danger">
                      *
                    </abbr>
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => setReviewQuery(e.target.value)}
                    value={reviewQuery}
                    className="br3"
                    placeholder="Write Query"
                    as="textarea"
                  />
                </Form.Group>
                <div className="text-end">
                  <button
                    onClick={addNewStudySubjectMedicalReviewComment}
                    disabled={openedAction || !reviewQuery}
                    className="updateProfile" style={{ fontSize: 12 }}>
                    {openedAction ? (
                      <div className="hstack gap-2">
                        <Spinner size="sm" /> Opening...
                      </div>
                    ) : (
                      "Open Now"
                    )}
                  </button>
                </div>
              </div>
            </Collapse>
          </div>
          {loader ? (
            <PageLoader />
          ) : queryList?.length === 0 ? (
            <div className="hstack justify-content-center h-100">
              <NoDataFoundTable MSG={"No Query"} />
            </div>
          ) : (
            queryList?.map((item, index) => (
              <div
                key={index}
                className="card p-3 mb-3"
                style={{
                  background: item?.status === "open" ? "#fff7ed" : "#f9fafb",
                  borderLeft: `4px solid ${item?.status === "open" ? "#f97316" : "#d1d5db"}`,
                }}
              >
                <div style={{ fontSize: 14 }}>{item?.comment}</div>

                <div className="small text-muted mt-2">
                  <b>Commented By</b>: {item?.openedByName} · {item?.openedDT}
                  {item?.status === "closed" &&
                    <>
                      · <b>Resolved By</b>: {item?.closedByName} · {item?.closedDT}
                    </>
                  }
                </div>
                {item?.status === "closed" &&
                  <div className="small text-muted mt-1">
                    <b>Remark</b>: {item?.remark || "NA"}
                  </div>
                }
                {item?.status === "open" && (StudyMode === "Live Mode" || StudyMode === "QC Mode") &&
                  <>
                    <button
                      onClick={() => setCloseAction(!closeAction)}
                      className="mt-2 updateProfile"
                      style={{ width: "max-content" }}
                    >
                      Close Now
                    </button>
                    <Collapse in={closeAction}>
                      <div>
                        <Form.Group className="mb-1">
                          <Form.Label className="fw-bold mb-1">
                            Reason{" "}
                            <abbr title="Required" className="text-danger">
                              *
                            </abbr>
                          </Form.Label>
                          <Form.Control
                            onChange={(e) => setRemark(e.target.value)}
                            value={remark}
                            className="br3"
                            placeholder="Reason"
                            as="textarea"
                          />
                        </Form.Group>
                        <div className="text-end">
                          <button
                            onClick={() => closedStudySubjectMedicalReviewComment(item?._id)}
                            disabled={closedAction === item?._id || !remark}
                            className="mt-2 updateProfile"
                            style={{ width: "max-content" }}
                          >
                            {closedAction ? (
                              <div className="hstack gap-2">
                                <Spinner size="sm" /> Closing...
                              </div>
                            ) : (
                              "Close"
                            )}
                          </button>
                        </div>
                      </div>
                    </Collapse>
                  </>


                }
              </div>
            )))}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ReviewQueryHistory;
